export default "__VITE_PUBLIC_ASSET__d1a72a8b__"